import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 6E06B49E-5127-4D5A-9C8B-F58BA8943BC4
 * name microsoft-windows
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-windows.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const MicrosoftWindowsIcon = createSvgIcon(<><path d="M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z" /></>, 'MicrosoftWindowsIcon');
export default MicrosoftWindowsIcon